import { fromJS } from 'immutable';

/**
 * Holds a local copy a courseware config, thus caching it.
 * Most of the methods are normal Map collection methods,
 * with the exception of getIn and setIn, which allows the use
 * of a path parameter.
 */
class Cache {
  constructor() {
    this.cache = fromJS({});
  }

  get(id) {
    return this.cache.get(id) && this.cache.get(id).toJS();
  }

  getIn(path) {
    return this.cache.getIn(path) && this.cache.getIn(path).toJS();
  }

  set(id, obj) {
    this.cache = this.cache.set(id, fromJS(obj));
  }

  setIn(path, obj) {
    this.cache = this.cache.setIn(path, fromJS(obj));
  }

  update(id, obj) {
    this.cache = this.cache.update(
      id, (arr) => arr.push(fromJS(obj))
    );
  }

  save(id, obj) {
    if (this.cache.get(id)) {
      this.update(id, obj);
    } else {
      this.set(id, [obj]);
    }
  }

  unsave(id, index) {
    this.cache = this.cache.deleteIn([id, index]); // Shifts down the indices
  }
}

export default Cache;
